import { Service } from '@angular/core';

/**
 * Global ng-bootstrap config
 *
 * @since 8.0.0
 */
@Service()
export class NgbConfig {
	animation = true;
}
